import { Divider } from "@ps-design-system/components/Divider";
import { Skeleton } from "@ps-design-system/components/Skeleton";

/** Loading placeholder matching ListingEditorLayout's two-column shell. */
const ListingEditorLayoutSkeleton = () => {
  return (
    <div className="listing-editor-page tw-grid tw-grid-cols-6">
      <div className="tw-col-span-6 md:tw-col-span-2 tw-flex tw-flex-col md:tw-border-r tw-border-r-gray-200 tw-pt-64 md:tw-pr-20 tw-min-h-[calc(100dvh-72px)]">
        <Skeleton height={24} width="40%" />
        <Skeleton height={32} width="80%" classNames="tw-mt-16" />
        <Skeleton height={20} width="60%" classNames="tw-mt-8" />
      </div>
      <div className="tw-col-span-6 md:tw-col-span-4 tw-flex tw-flex-col md:tw-pt-64 md:tw-pl-20 tw-min-h-[calc(100dvh-72px)]">
        <Skeleton height={32} width="40%" />

        <Divider spacing={24} />

        <Skeleton height={45} width="100%" />
        <Skeleton height={120} width="100%" classNames="tw-mt-24" />
        <Skeleton height={45} width="100%" classNames="tw-mt-24" />
        <Skeleton height={45} width={250} classNames="tw-mt-24" />
        <Skeleton height={45} width={250} classNames="tw-mt-24" />

        <Divider spacing={24} />

        <div className="tw-flex tw-justify-end">
          <Skeleton height={40} width={68} />
        </div>
      </div>
    </div>
  );
};

export { ListingEditorLayoutSkeleton };
